package com.rainbowclubs.rainbow.domain.use_cases.login

import com.rainbowclubs.rainbow.data.responses.SelectClubResponse
import com.rainbowclubs.rainbow.domain.repositories.SelectClubRepository

class SelectClubUseCase(
    private val selectClubRepository: SelectClubRepository,
) {
    suspend operator fun invoke(): Result<SelectClubResponse> {
        return try {

            selectClubRepository.getSelectedClubs().onSuccess {
                return Result.success(it)
            }.onFailure {
                return Result.failure(it)
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}